import { useNavigate } from 'react-router-dom';
import styles from './BackButton.module.scss';

const BackButton = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Regresa a la página anterior en el historial
  };

  return (
    <button
      onClick={handleBack}
      className={styles.backButton}>
      {'◄ Volver'}
    </button>
  );
};

export default BackButton;
